import type { FaireProductEntity } from "../../entity_types/product";

export const p_afsggc4zrd: FaireProductEntity = {
  token: "p_afsggc4zrd",
  type: "product",
  name: "Pilates Slut Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/230dd9ab0da315b5ff38fe49edc32f888b4427db8176ca2dccec679c4656b90a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0cfa83fe8666e9e2485b6621e9c054da2a59079ab44d815e977e1d1f66d02f6.jpeg",
    "https://cdn.faire.com/fastly/e363756cd71998eed651f2abb08493587a0a4950115b5bdfc4c314ee38dc8192.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/079da29d72b3842ad91b992dcb20bb7e8c448193891ff1ef5e7155cfab82f7ac.jpeg",
    "https://cdn.faire.com/fastly/f3cffaaa4f58aa952e0eb3b6d147efc28b29960887b619ae81a1c6d54b8790d7.jpeg",
    "https://cdn.faire.com/fastly/326b849240b2eb0fe2ee4af24c1e27cd1915ac250fbe796b2950966093504b22.jpeg",
    "https://cdn.faire.com/fastly/8b7d2be768ac3a3d27b7bb9139bec3b4b3459c9f390d1540c7a176252a94b096.jpeg"
  ],
  priceDollars: 9.6,
  description: "For anyone who's ever rearranged their day around getting to ride that Reformer. This grip sock is for you.\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:23.399Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
